import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "./menu.scss";
import { useTranslation } from "react-i18next";
import { error } from "../common/helpers/toastify";
import CheckoutBlankCopy from "../checkout/checkoutBlankcopy";
import StoreModal from "../common/Modals/StoreModal";
import posscreenimg from "../../assets/images/posmenusvg.svg";
import customimage from "../../assets/images/custommenusvg.svg";
import repairimage from "../../assets/images/repairmenusvg.svg";
import exchangeimage from "../../assets/images/exchangemenusvg.svg";
import refundimage from "../../assets/images/refundmenusvg.svg";
import reserveimage from "../../assets/images/reservemenusvg.svg";
import receiveimage from "../../assets/images/receivemenusvg.svg";
import catalogimage from "../../assets/images/catalogmenusvg.svg";
import wishlistimage from "../../assets/images/wishlistmenusvg.svg";
import quotationimage from "../../assets/images/quotationmenusvg.svg";
import appointmentimage from "../../assets/images/appointmentmenusvg.svg";
import giftcardimage from "../../assets/images/giftcardmenusvg.svg";
import quickviewimg from "../../assets/images/quickviewmenusvg.svg";
import customerimage from "../../assets/images/customermenusvg.svg";
import zoneimage from "../../assets/images/zonemenusvg.svg";
import faromainicon from "../../assets/images/faromainicon.svg";
import {
  clearFaroCustomOrderActive,
} from "../catalog/faroSession";

const MenuCopy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const posOrgSettings = useSelector((state) => state.app.posorganisation_settings);
  const isFaroActive = posOrgSettings?.faro_active === 1;

  useEffect(() => {
    clearFaroCustomOrderActive();
  }, []);

  const handleFaroClick = (e) => {
    if (!isFaroActive) {
      e.preventDefault();
      error(t("Please activate Claude and Voyage both in Settings > Integrated Applications"));
    }
  };

  const menuItems = [
    {
      key: "pos",
      title: "POS",
      image: posscreenimg,
      color: "#5CC7C1",
      to: "/app/pos/posscreen",
      size: "hero",
      section: "top-hero",
    },
    {
      key: "custom",
      title: "Custom",
      image: customimage,
      color: "#FF8684",
      to: "/app/pos/custom/custom",
      section: "top",
    },
    {
      key: "exchange",
      title: "Exchange",
      image: exchangeimage,
      color: "#F8A97D",
      to: "/app/pos/exchange",
      section: "top",
    },
    {
      key: "refund",
      title: "Refund",
      image: refundimage,
      color: "#6AA2B2",
      to: "/app/pos/refund",
      section: "top",
    },
    {
      key: "reserve",
      title: "Reserve",
      image: reserveimage,
      color: "#F9BC44",
      to: "/app/pos/reserve",
      section: "top",
    },
    {
      key: "receive",
      title: "Receive",
      image: receiveimage,
      color: "#87D283",
      to: "/app/pos/receive",
      section: "top",
    },
    {
      key: "repair",
      title: "Repair",
      image: repairimage,
      color: "#B2B3F5",
      to: "/app/pos/repair",
      section: "top",
    },
    {
      key: "wishlist",
      title: "Wishlist",
      image: wishlistimage,
      color: "#FF5757",
      to: "/app/pos/wishlist",
      section: "bottom",
    },
    {
      key: "customer",
      title: "Customer",
      image: customerimage,
      color: "#FC84B4",
      to: "/app/pos/customer/customer",
      section: "bottom",
    },
    {
      key: "quotation",
      title: "Quotation",
      image: quotationimage,
      color: "#4E8EF0",
      to: "/app/pos/Quotation",
      section: "bottom",
    },
    {
      key: "catalog",
      title: "Catalog",
      image: catalogimage,
      color: "#757575",
      to: "/app/pos/catalog/CollectionList",
      size: "wide",
      section: "bottom",
    },
    {
      key: "giftcard",
      title: "Gift Card",
      image: giftcardimage,
      color: "#C9B07D",
      section: "bottom",
      onClick: () => navigate("/app/pos/card", { state: { fromClick: true } }),
    },
    {
      key: "appointment",
      title: "Appointment",
      image: appointmentimage,
      color: "#A87762",
      to: "/app/pos/appointment",
      section: "bottom",
    },
    {
      key: "zone",
      title: "Zone",
      image: zoneimage,
      color: "#6ACDFF",
      to: "/app/pos/zone",
      section: "bottom",
    },
    {
      key: "quickview",
      title: "Quickview",
      image: quickviewimg,
      color: "#9E69B4",
      to: "/app/pos/Quickview",
      size: "wide",
      section: "bottom",
    },
  ];

  const renderMenuTile = (item) => {
    const tileClassName = `menu-block__tile menu-block__tile--${item.key}${
      item.size ? ` menu-block__tile--${item.size}` : ""
    }`;
    const tileStyle = { "--menu-tile-color": item.color };
    const tileContent = (
      <>
        <span className="menu-block__tile-icon-wrap" aria-hidden>
          <img className="menu-block__tile-icon" src={item.image} alt="" />
        </span>
        <span className="menu-block__tile-title">{t(item.title)}</span>
      </>
    );

    if (item.onClick) {
      return (
        <button
          key={item.key}
          type="button"
          className={tileClassName}
          style={tileStyle}
          onClick={item.onClick}
        >
          {tileContent}
        </button>
      );
    }

    return (
      <Link
        key={item.key}
        to={item.to}
        className={tileClassName}
        style={tileStyle}
      >
        {tileContent}
      </Link>
    );
  };

  const topSmallItems = menuItems.filter((item) => item.section === "top");
  const bottomItems = menuItems.filter((item) => item.section === "bottom");

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="menu-block">
              <h1 className="main-heading">{t("MENU")}</h1>
              <div className="menu-block__grid" aria-label={t("MENU")}>
                <div className="menu-block__top-row">
                  {renderMenuTile(menuItems.find((item) => item.key === "pos"))}
                  <div className="menu-block__top-small-grid">
                    {topSmallItems.map(renderMenuTile)}
                  </div>
                </div>
                <div className="menu-block__bottom-grid">
                  {bottomItems.map(renderMenuTile)}
                </div>
              </div>
              <Link
                to="/app/pos/catalog/smart-search"
                className="menu-block__faro-search"
                aria-label={t("FARO Search")}
                aria-disabled={!isFaroActive}
                onClick={handleFaroClick}
                style={!isFaroActive ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                // title={t("FARO Search")}
              >
                {/* <img src={faromainicon} alt="" aria-hidden /> */}
                <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto",marginTop:0 }}
        >
                <img src={faromainicon} alt="" aria-hidden />
                <span className="kycTooltip-area-up-text" style={{  minWidth:'32px',padding:'5px 5px',  bottom: 'calc(100% - -4px)'}}>faro</span>

              </div>
              </Link>
            </div>
          </div>
          <div className="main-body-row-right-col">
            <CheckoutBlankCopy />
          </div>
        </div>
        <StoreModal />
      </div>
    </>
  );
};

export default MenuCopy;